import { render, staticRenderFns } from "./Create-Payment-Invoices.vue?vue&type=template&id=398c2e2e"
import script from "./Create-Payment-Invoices.vue?vue&type=script&lang=js"
export * from "./Create-Payment-Invoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports